import { Card } from "@/components/ui/card";

export default function StatCard({ label, value, sub, icon: Icon, tone = "neutral", testid }) {
  const tones = {
    neutral: "border-border",
    success: "border-emerald-200 dark:border-emerald-800",
    danger: "border-rose-200 dark:border-rose-800",
    primary: "border-primary/40",
  };
  const iconTones = {
    neutral: "bg-muted text-muted-foreground",
    success: "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400",
    danger: "bg-rose-500/10 text-rose-600 dark:text-rose-400",
    primary: "bg-primary/10 text-primary",
  };
  return (
    <Card data-testid={testid} className={`p-4 card-hover ${tones[tone]}`}>
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-xs uppercase tracking-wide text-muted-foreground font-medium">{label}</p>
          <p className="mt-1.5 money text-xl lg:text-2xl font-semibold tracking-tight">{value}</p>
          {sub && <p className="mt-0.5 text-xs text-muted-foreground">{sub}</p>}
        </div>
        {Icon && (
          <div className={`h-9 w-9 rounded-lg grid place-items-center shrink-0 ${iconTones[tone]}`}>
            <Icon className="h-4 w-4" />
          </div>
        )}
      </div>
    </Card>
  );
}
